import { AbstractPmsApiService } from "./abstract.service";
import { PropertyType } from "../models";

/**
 * @class PropertyTypePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<PropertyType>}
 */
export class PropertyTypePmsApiService extends AbstractPmsApiService {

    /**
     * @propertyType {string}
     * @protected
     */
    get urlPattern() {

        return '/type(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {PropertyType}
     * @protected
     */
    newModel(attributes) {

        return new PropertyType(attributes);
    }

    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<PropertyType>>}
     */
    get (params = {}) {

        const url = this.url();
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {PropertyType} propertyType
     * @returns {Promise.<PropertyType>}
     */
    create(propertyType) {

        const url = this.url();

        return this.http
                   .post(url, propertyType, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {PropertyType} propertyType
     * @returns {Promise.<PropertyType>}
     */
    update(propertyType) {

        const url = this.url({id: propertyType.id});

        return this.http
                   .put(url, propertyType, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {PropertyType} propertyType
     * @returns {Promise.<boolean>}
     */
    delete(propertyType) {

        const url = this.url({id: propertyType.id});

        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }

    /**

     * @param {Integer} typeId
     * @param {Object} params
     */
    show(typeId, params = {}) {

        const url = this.url({
            id: typeId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<PropertyType>>}
     */
    getPublic(params = {}) {

        const url = this.url({
            id: 'public',
        });

        return this.http
            .get(url, {
                headers: this.headers,
                params,
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }

    getWithDeletedProperties(params = {}) {

        const url = this.url({
            id: 'with-deleted-properties',
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/property-type.service.js